// Which roles see a field (grid column, editor field, total) — keyed by field id
// without a trailing "Id", or by its object. A field not listed is visible to all.
//
// The roles are the backend's system roles: admin, merchant, agent, gateway
// (SystemRoles in x-backend). This list came from allpaypays, whose admin role was
// `appz` and provider role `psp`; neither exists here, so every field below was
// hidden from admins — the merchant terminal, commissions and system account
// columns among them. fieldVisibilityConfig.test.js keeps the names in step.
// What a gateway user may not see is the deny-list in permissions.config.js.
export const fieldVisibilityConfig = {
    extraFilter: ['admin'],
    commissionAgentJson: ['admin'],
    commissionMerchantJson: ['admin'],
    commissionGwJson: ['admin'],
    systemAccount: ['admin'],
    terminalGateway: ['admin'],
    merchantTerminal: ['admin'],
    totalPaymentsBalance: ['admin', 'agent'],
    totalPayoutsBalance: ['admin', 'agent'],
    totalFees: ['admin', 'agent'],
    totalDepositsBalance: ['admin', 'agent'],
    totalWithdrawalsBalance: ['admin', 'agent'],
    currentBalance: ['admin', 'agent'],
    totalAgentCommission: ['admin'],
    totalIncludedCommission: ['admin', 'merchant'],
    totalOntopCommission: ['admin', 'merchant'],
    totalIncludedCommissionGwCost: ['admin'],
    totalOntopCommissionGwCost: ['admin'],
    cascadingStatus: ['admin', 'agent'],
    originalPaymentId: ['admin'],
    internalStateDescription: ['admin'],
    ecomCascadeRule: ['admin'],
    p2pCascadeRule: ['admin'],
    payoutCascadeRule: ['admin'],
    redirectCascadeRule: ['admin'],
};
